import React from "react";
import { useTranslation } from "react-i18next";
import { IconHeart, IconDroplet, IconMan } from "@tabler/icons-react";

import FooterDrawer from "@/components/ui/atoms/FooterDrawer";
import { VitalsParameter } from "@/types/vitals";

import styles from "./ChooseVitalDrawer.module.css";

export interface ChooseVitalDrawerProps {
  open: boolean;
  onClose: () => void;
  onSelect: (parameter: VitalsParameter) => void;
}

const ChooseVitalDrawer: React.FC<ChooseVitalDrawerProps> = ({
  open,
  onClose,
  onSelect,
}) => {
  const { t } = useTranslation();

  const options: {
    parameter: VitalsParameter;
    icon: React.ReactNode;
    iconClassName: string;
    title: string;
    description: string;
  }[] = [
    {
      parameter: VitalsParameter.BP,
      icon: <IconHeart size={24} />,
      iconClassName: styles.iconChipBp,
      title: t("vitalsTracker.bloodPressure"),
      description: t("vitalsTracker.bloodPressureSubtitle"),
    },
    {
      parameter: VitalsParameter.GLUCOSE,
      icon: <IconDroplet size={24} />,
      iconClassName: styles.iconChipGlucose,
      title: t("vitalsTracker.bloodSugar"),
      description: t("vitalsTracker.bloodSugarSubtitle"),
    },
    {
      parameter: VitalsParameter.WEIGHT,
      icon: <IconMan size={24} />,
      iconClassName: styles.iconChipWeight,
      title: t("vitalsTracker.weight"),
      description: t("vitalsTracker.weightSubtitle"),
    },
  ];

  return (
    <FooterDrawer
      open={open}
      onClose={onClose}
      title={t("vitalsTracker.chooseVital")}
      showClose
      height="auto"
      containerZIndex={9999999999}
    >
      <div className={styles.list}>
        {options.map((opt) => (
          <button
            key={opt.parameter}
            type="button"
            className={styles.optionRow}
            onClick={() => onSelect(opt.parameter)}
          >
            <span className={`${styles.iconChip} ${opt.iconClassName}`}>
              {opt.icon}
            </span>
            <span className={styles.textCol}>
              <span className={styles.optionTitle}>{opt.title}</span>
              <span className={styles.optionDescription}>
                {opt.description}
              </span>
            </span>
          </button>
        ))}
      </div>
    </FooterDrawer>
  );
};

export default ChooseVitalDrawer;
